export default __webpack_public_path__ + "static/header-bird-902782cc7986509f2dccb13b1404b863.gif";